'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:WorkspaceService
 * @description
 * # WorkspaceService
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('Workspace', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_WORKSPACE_URL = domain.name + '/api/v1/workspaces/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_WORKSPACE_URL,
      baseModelName: 'workspace'
    });

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    baseService.toggleNotification = function(params) {
      return $http.put(BASE_WORKSPACE_URL + params.workspace.id + "/toggle_notification", params)
    }

    return baseService;
  }]);
